<template>
  <div class="wrapper">
    <div class="main-panel">
      <div class="main-content">
        <div class="content-wrapper">
          <div class="container-fluid">
            <section class="basic-elements">
              <div class="row">
                <div class="col-sm-12">
                  <a class="btn btn-secondary float-right top-back-button" @click.prevent="back()"><i class="fa fa-arrow-left"></i></a>
                  <h2 class="content-header">{{ this.$t("labels.newPatient") }}</h2>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="card">
                    
                    <div class="card-body">
                      <div class="px-3">
                        <form class="form">
                          <PatientForm :patient="patient" ref="newPatientForm" />
                          <div class="form-actions">
                            <button type="button" class="btn btn-info mr-1" @click.prevent="back()">
                              <i class="fa fa-arrow-left"></i> {{ this.$t("labels.back") }}
                            </button>
                            <button type="button" class="btn btn-success" @click.prevent="createPatient()">
                              <i class="icon-note"></i> {{ this.$t("labels.save") }}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <dev-footer />
    </div>
  </div>
</template>

<script>
import PatientService from "../../services/patient";
import StorageService from '../../services/storage'
import PatientForm from './PatientForm'
import Progress from '@/components/patient/Progress.vue'
import DevFooter from '../DevFooter'

export default {
  components: {
    PatientForm,
    DevFooter,
    Progress
  },
  data: () => {
    return {
      therapyForm: true,
      errors: [],
      patient: {
        changeTherapy: true,
        default: true,
        actualTherapy: {
          drugs: []
        },
        country: 'Italy',
        dravetNetParticipant: false,
        emergencyNumbers: []
      }
    }
  },
  methods: {
    back() {
      this.$router.push({ name: 'home'})
    },
    createPatient: async function() {
        this.errors = []
        let loader = this.$loading.show({
            color: '#ccc',
            loader: 'spinner'
        },{
            after: this.$createElement('Progress')
        })
        this.$refs.newPatientForm.setSize()
        if (!this.patient.name || this.patient.name.length == 0) {
          this.errors.push(this.$t("errors.cantBeEmpty", [this.$t('labels.name')]))
        }
        if (!this.patient.surname || this.patient.surname.length == 0) {
          this.errors.push(this.$t("errors.cantBeEmpty", [this.$t('labels.surname')]))
        }
        //if (!this.patient.birthDate || this.patient.birthDate.length == 0) {
        //  this.errors.push(this.$t("errors.cantBeEmpty", [this.$t('labels.birthDate')]))
        //}
        //if (!this.patient.street || this.patient.street.length == 0) {
        //  this.errors.push(this.$t("errors.cantBeEmpty", ['Street']))
        //}
        //if (!this.patient.city || this.patient.city.length == 0) {
        //  this.errors.push(this.$t("errors.cantBeEmpty", ['City']))
        //}
        //if (!this.patient.zipCode || this.patient.zipCode.length == 0) {
        //  this.errors.push(this.$t("errors.cantBeEmpty", ['Zip code']))
        //}
        //if (!this.patient.province || this.patient.province.length == 0) {
        //  this.errors.push(this.$t("errors.cantBeEmpty", ['Province']))
        //}
        //if (!this.patient.region || this.patient.region.length == 0) {
        //  this.errors.push(this.$t("errors.cantBeEmpty", ['Region']))
        //}
        //if (!this.patient.country || this.patient.country.length == 0) {
        //  this.errors.push(this.$t("errors.cantBeEmpty", ['Country']))
        //}
        //if (!this.patient.actualTherapy.drugs || this.patient.actualTherapy.drugs.length === 0) {
        //  this.errors.push(this.$t("errors.cantBeEmpty", [this.$t('labels.drugs')]))
        //}
        //let bloodGroup = this.patient.bloodGroup
        //if (!bloodGroup || bloodGroup.length == 0) {
        //  this.errors.push(this.$t("errors.cantBeEmpty", [this.$t('labels.bloodGroup')]))
        //}
        //let heightCm = this.patient.heightCm
        //if (!heightCm || heightCm.length == 0) {
        //  this.errors.push(this.$t("errors.cantBeEmpty", [this.$t('labels.heightCm')]))
        //}
        //if (typeof heightCm !== 'number') {
        //this.errors.push(this.$t("errors.notNumber", [this.$t('labels.heightCm')]))
        //}
        //let weightKg = this.patient.weightKg
        //if (!weightKg || weightKg.length == 0) {
        //  this.errors.push(this.$t("errors.cantBeEmpty", [this.$t('labels.weightKg')]))
        //}
        //if (typeof weightKg !== 'number') {
        //  this.errors.push(this.$t("errors.notNumber", [this.$t('labels.weightKg')]))
        //}
        //let dravetNetParticipant = this.patient.dravetNetParticipant
        //if (!dravetNetParticipant  || dravetNetParticipant.length == 0) {
        //  this.errors.push(this.$t("errors.cantBeEmpty", ['DravetNet participation']))
        // }
        //if (typeof dravetNetParticipant !== 'boolean') {
        //  this.errors.push(this.$t("errors.notBoolean", ['DravetNet participant']))
        //}
        const allowedFileTypes = ['application/pdf']
        if (this.patient.certificate) {
            if (!allowedFileTypes.includes(this.patient.certificate.type)) {
                this.errors.push(this.$t("errors.wrongFiletype", [this.patient.certificate.name]))
            }
            let certificateSizeMb = this.patient.certificate.size/1024/1024
            if (certificateSizeMb > 5) {
                this.errors.push(this.$t("errors.tooLarge", [this.patient.certificate.name]))
            }
        }
        const allowedImageTypes = ['image/jpeg', 'image/png', 'image/gif']
        if (this.patient.avatar) {
            if (!allowedImageTypes.includes(this.patient.avatar.type)) {
                this.errors.push(this.$t("errors.wrongFiletype", [this.patient.avatar.name]))
            }
            let avatarSizeMb = this.patient.avatar.size/1024/1024
            if (avatarSizeMb > 5) {
                this.errors.push(this.$t("errors.tooLarge", [this.patient.avatar.name]))
            }
        }
        if (this.errors.length == 0) {
          let formData = new FormData()
          formData.append('certificate', this.patient.certificate)
          formData.append('avatar', this.patient.avatar)
          formData.append('patient', JSON.stringify(this.patient))
          const result = await PatientService.create(formData)
          if (result.data.success === true) {
            this.$store.dispatch('allPatients')
            this.$router.push({ name: 'home' })
            this.$miniToastr.success(this.$t("flash.createSuccess"))
          } else {
            for (let error in result.data.errors) {
              this.errors.push(result.data.errors[error].msg)
            }
            this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
            this.errors = []
          }
        } else {
          this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
          this.errors = []
        }
        loader.hide()
        this.$store.state.currentProgress = 0
    },
    back: function() {
      this.$router.push({ name: 'home' })
    }
  }
};
</script>

<style>
</style>
